import { parseBoolean } from '@gitlab/frontend-utils';
import { initVueApp } from '/builds/gitlab/gitlab-ee/app/assets/javascripts/lib/utils/vue3compat/init_vue_app.js?vue3';
import apolloProvider from '/builds/gitlab/gitlab-ee/app/assets/javascripts/repository/graphql.js?vue3';
import RepositoryApp from '~/repository/components/app.vue';
import createStore from '/builds/gitlab/gitlab-ee/app/assets/javascripts/code_navigation/store/index.js?vue3';

export default function initRepositoryApp(router, options = {}) {
  const viewBlobEl = document.querySelector('#js-view-blob-app');
  const {
    blobPath,
    projectPath,
    refType,
    originalBranch,
    resourceId,
    explainCodeAvailable,
    canDownloadCode,
    hasRevsFile,
    highlightWorker,
  } = options;

  if (!viewBlobEl || !blobPath || !projectPath || !highlightWorker) return null;

  return initVueApp({
    el: viewBlobEl,
    name: 'RepositoryAppRoot',
    store: createStore(),
    router,
    apolloProvider,
    provide: {
      highlightWorker,
      originalBranch,
      resourceId,
      explainCodeAvailable: parseBoolean(explainCodeAvailable),
      canDownloadCode: parseBoolean(canDownloadCode),
      hasRevsFile: parseBoolean(hasRevsFile),
    },
    component: RepositoryApp,
    props: {
      projectPath,
      refType,
    },
  });
}
